<template>
	<el-card class="box-card" shadow="never">
		<div slot="header" class="clearfix" v-if="(gridlist_lang.gridtitle!=''&&gridlist_lang.gridtitle!=undefined)">
			<span>{{gridlist_lang.gridtitle }}</span>
		</div>
		<div v-for="(i, idx) in pageset[0].setlist" style="margin-top:-10px">
			<div v-if="i.controltype == 'table'">
				<tableui
					:ref="'gridedit_'+l_id"
					editcell="1"
					:tablemain="i[i.colkey]"
					:columns="columns"
					@gridhandle="val => gridhandle(val, i, idx)"
					@autoaddrow="val => gridhandle(val, i, idx)"
					@checkboxchange="checkboxchange"
					@gridchange="gridchange"
					:rowclassname="setrowclass"
					@cellclick="cellclick"
					:gridheight="gridheight"
					@getExpandsRow="getExpandsInfo"
					:rowkey="rowkey"
					@callbackFun="callbackFun"
					:maincounttype="type"
				></tableui>
				<el-row v-if="gridsum" style="margin-top:10px">
					<el-col :span="1">
						<span style="color:transparent;">1</span>
					</el-col>
					<el-col :span="22" style="text-align:right;">
							<label v-for="(item,index) in summarylist" class="summary" :key="index"><span class="title">{{item.label}}</span> : <span class="value">{{item.value}}</span> </label>
					</el-col>
					<el-col :span="1">
						<span style="color:transparent;">1</span>
					</el-col>
				</el-row>
			</div>
		</div>
		<dialogwin ref="dialogwin" @dialogsrue="dialogsrue"></dialogwin>
	</el-card>
</template>
<script>
import Utils from '../../lib/util.js';
import dialogwin from '@/components/tools/dialogwin.vue';
import tableui from '@/components/table/tablegrid_expand_edit.vue';
export default {
	components: {
		tableui,
		dialogwin
	},
	props: {
		
		classname: {
			type: String,
			default:''
		},
		l_mode:{
			type: String,
			default:''
		},
		isdetail:{
			type:Boolean,
			default:false
		},
		l_id:{
			type:String,
			default:''
		},
		gridsum:{
			type:Boolean,
			default:false
		},
		checkcountsum:{
			type:Boolean,
			default:false
		},
		isadd:{
			type:Boolean,
			default:true
		},
		ischecksingle:{
			type:Boolean,
			default:false
		},
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		rowkey:{
			type: String,
			default: ''
		}
	},
	data() {
		return{
			pageset:[{setlist:[]}],
			syscol:'',
			loading:false,
			orderinfo:'',
			gridlist_lang:{},
			//title:'',
			ischecked:false,
			columns:[],
			handle: {
				field: '',
				title: '操作',
				type: 'template',
				template: [
					{ type: 'link', title: '添加', icon: '', handletype: 'success', event: 'addrow' },
					{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
				],
				width: 120,
				sortable: false,
				evttype: 'click',
				colshow: '1',
				event: ''
			},
			handlenotadd: {
				field: '',
				title: '操作',
				type: 'template',
				template: [
					{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
				],
				width: 120,
				sortable: false,
				evttype: 'click',
				colshow: '1',
				event: ''
			},
			summarylist:[],//{label:'美元',value:20},{label:'人民币',value:200}
			sumarycol:[],
			amount:0,
			checkedrows:[],
			gridrowindex:-1,
			gridheight:'',
			cargorow:[],
			type:''
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/gridlist.scss');
		//this.init();
	},
	methods:{
		init(param){
			//debugger
			this.orderinfo='';
			this.title='';
			this.ischecked=false;
			
			if(param.syscol!=undefined)
				this.syscol=param.syscol;
			if(param.p_mode!=undefined)
				this.p_mode=param.p_mode;
			if(param.type!=undefined)
				this.type=param.type;	
			if(param.orderinfo!=undefined)
				this.orderinfo=param.orderinfo;
			if(param.pkval!=undefined)
				this.pkval=param.pkval;	
			if(param.ischecked!=undefined)
				this.ischecked=param.ischecked;
			if(param.title!=undefined)
				this.title=param.title;
			if(param.sumarycol!=undefined)
				this.sumarycol=param.sumarycol;
			if(param.gridheight!=undefined)
				this.gridheight=param.gridheight;
			if(this.gridheight=='')
				this.gridheight=(window.innerHeight *52) / 100 + 'px';
			this.pageset=[{setlist:[]}];
			this.loadlanguage();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode(this.type,this).then(res=>{
				//debugger
				if(res.state=='1')
					that.gridlist_lang=that.$lang.label[that.type];
				that.getsetlist();
			});
		},
		getsetlist(){
			var that=this;
			//debugger
			this.$apipost.get.GetPagecolSet({syscol:this.syscol,l_mode:this.type}).then(res => {
				//debugger
				if(res.length>0){
					var columns=[];
					res.forEach(e=>{
						if(that.gridlist_lang[e.showname]!=undefined)
							e.showname=that.gridlist_lang[e.showname];
						if(e.controltype=='table'){
							//debugger
							columns=JSON.parse(JSON.stringify(e.table));
							e[e.colkey] = [];
						}
					});
					if(columns.length>0){
						if(!that.isdetail){
							that.handle.index = columns.length + 1;
							if(that.isadd)
								columns.push(that.handle);
							else
								columns.push(that.handlenotadd);
						}else{
							columns.forEach(e=>{
								if(e.type!='openurl')
									e.type='text';
							});
						}
						columns.forEach(e=>{
							if(that.gridlist_lang[e.title]!=undefined)
								e.title=that.gridlist_lang[e.title];
						});
					}
					if(that.ischecked)
						columns.unshift({field:'checkbox',title:'',type:''});
					 that.columns =columns;
					// this.setlist=res;
					 that.setgridcol(columns);
					 //debugger
					 that.setpagelayout(res);
				}
			});
		},
		//生成默认行
		setgridcol(colset) {
			var cols = '';
			colset.forEach(e => {
				if (e.type != 'template'&&e.field!='checkbox') {
					cols += '"' + e.field + '":"",';
				}
			});
			if (cols != '') {
				cols += '"expand":false,"showexpand":false,"item":{},"urlparam":{},"rowid":"","expandlist":[],';
				cols = cols.substring(0, cols.length - 1);
			}
			cols = '[{' + cols + '}]';
			this.cargorow = JSON.parse(cols)[0];			
		},
		//设置页面数据
		setpagelayout(res) {
			var that = this;
			var setlist=[];
			
			if(res==undefined)
				res=this.pageset[0].setlist;
			else
				this.pageset = [];
			var isgrid=false;
			res.forEach(s => {
				if (s.controltype == 'table') {
					var newrow=JSON.parse(JSON.stringify(this.cargorow));
					newrow.rowid=this.$tool.createUniqueId();
					s[s.colkey] = [];
					//debugger
					if(that.orderinfo[s.colkey]!=undefined)
					{
						if(that.orderinfo[s.colkey].length>0)
							s[s.colkey]=that.orderinfo[s.colkey];
						else
						{
							if(!that.isdetail&&that.isadd)
								s[s.colkey].push(newrow);
						}	
					}
					else{
						if(!that.isdetail&&that.isadd)
							s[s.colkey].push(newrow);
					}
					setlist.push(s);
				}
			});
			this.pageset.push({ setlist:setlist});
			//是否需要汇总
			if(this.isdetail&&this.gridsum){
				this.gridSumCol();
			}
		},
		cellclick(e){
			//debugger
			if(e.column.type=='openurl'){
				//debugger
				var templates=e.column.template;
				var par='';
				templates.forEach(b=>{
					if(e.row[b.col]==b.urltype){
						par=b.urlparam;
						return false;
					}
				});
				if(par!=''){
					var b=par;
					b.row=e.row;
					b.row[par.colname]=e.row[par.colkey];
					this.$public.ActionControl(b,this);
				}
			}
		},
		//列表操作列
		gridhandle(e, i, index) {
			var that = this;
			this.gridrowindex=e.index;
			if (e.event == 'addrow') {
				//debugger
				this.addnewrow(JSON.parse(JSON.stringify(this.cargorow)));
			}
			if (e.event == 'delrow') {
				this.deleteRow(e, i, index);
			}
			if(e.event=='getpkcargo'){
				var pkval=e.row[e.field].toString().trim();
				var isopen=false;
				if(pkval!=''){
					//按商品货号查找
					var param={pkval:pkval};
					
					this.$apipost.get.CreateGrid({
					l_mode:'货品管理',
					tab:'tab1',
					pageindex:0,
					showcol:'',
					pagesize:200,
					sort:' u_createtime desc',
					search:" and pkcno='"+pkval+"'",
					listparam:'',
					iscount:false,
					userid:localStorage.getItem('userid')}).then(res => {
						if(res.data.length==1){
							if(that.gridrowindex==-1)
								that.gridrowindex=0;
							that.addrow({rows:res.data});
						}else{
							that.openselectcargo({event:e.event});
						}
					});
				}
				else
					this.openselectcargo({event:e.event});
			}
			if(e.event=='geterpcargo'){
				//debugger
				var pkval=e.row[e.field].toString().trim();
				var isopen=false;
				if(pkval!=''){
					//按商品货号查找
					var param={pkval:pkval};
					this.$apipost.get.CreateGrid({
					l_mode:'货品管理',
					tab:'tab1',
					pageindex:0,
					showcol:'',
					pagesize:200,
					sort:' u_createtime desc',
					search:" and pkcno='"+pkval+"'",
					listparam:'',
					iscount:false,
					userid:localStorage.getItem('userid')}).then(res => {
						if(res.data.length==1){
							if(that.gridrowindex==-1)
								that.gridrowindex=0;
							that.addrow({rows:res.data,event:e});
						}else{
							that.openselectcargo({event:e.event});
						}
					});
				}
				else
					this.openselectcargo({event:e.event});
			}
		},
		openselectcargo(e){
			var that=this;
			this.$apipost.get.GetLinkInfo({ l_id:571 }).then(res => {
				//debugger
				if (res.info != undefined) {
					var paramitem=res.info;
					paramitem.iswin=true;
					that.$refs.dialogwin.init({item:paramitem,title:that.gridlist_lang.selectpkcargo,callbackparam:e});
				} else that.$tool.message('此功能无法启用', 0);
			});
		},
		addnewrow(row,index){
			//debugger
			this.pageset[0].setlist.forEach(s => {
				if (s.controltype == 'table') {
					if(index!=undefined)
						s[s.colkey].splice(index,1);
					row.rowid=this.$tool.createUniqueId();	
					s[s.colkey].push(row);
					return false;
				}
			});
			if(index!=undefined)
				this.$refs['gridedit_'+this.l_id][0].$children[0].clearSelection();
		},
		addrow(e){
			this.addcargorow(e.rows,undefined,e.isclose,e.event);
		},
		//填写行
		addcargorow(rows,i, isclose,callbackparam) {
			debugger
			var isset=false;
			if (isclose == undefined) isclose = false;
			var that = this;
			var newrow=JSON.parse(JSON.stringify(this.cargorow));
			newrow.rowid=this.$tool.createUniqueId();	
			var rowindex = this.gridrowindex;
			if(i!=undefined){
				rows.forEach(e => {
					if(callbackparam!=undefined)
					{
						if(callbackparam.event=='geterpcargo'){
							if(e.isbatch=='是')
								e.showexpand=true;
						}
					}	
					if (rowindex > that.gridrowindex) i[i.colkey].splice(rowindex, 0,newrow );
					else if(rowindex==that.gridrowindex) s[s.colkey].splice(rowindex, 1,newrow);
					
					for (var key in i[i.colkey][rowindex]) {
						for (var cargokey in e) {
							if (cargokey == key) {
								i[i.colkey][rowindex][key] = e[key];
								break;
							}
						}
						if (key == 'num'&&i[i.colkey][rowindex][key]=='') i[i.colkey][rowindex][key] = '1';
					}
					rowindex++;
				});
			}
			else{
				that.pageset.forEach(p=>{
					p.setlist.forEach(s=>{
						if(s.controltype=='table')
						{
							rows.forEach(e => {
								if(callbackparam!=undefined)
								{
									if(callbackparam.event=='geterpcargo'){
										if(e.isbatch=='是')
											e.showexpand=true;
									}
								}
								if (rowindex > that.gridrowindex) s[s.colkey].splice(rowindex, 0,newrow);
								else if(rowindex==that.gridrowindex) s[s.colkey].splice(rowindex, 1,newrow);
								for (var key in s[s.colkey][rowindex]) {
									for (var cargokey in e) {
										if (cargokey == key) {
											s[s.colkey][rowindex][key] = e[key];
											break;
										}
									}
									if (key == 'num'&&s[s.colkey][rowindex][key]=='') s[s.colkey][rowindex][key] = '1';
								}
								rowindex++;
							});
							isset=true;
							return false;
						}
					});
					if(isset)
						return false;
				});
			}
			if (isclose) this.closecargo();
			else {
				if (rows.length > 0) {
					//debugger
					this.$refs['gridedit_'+this.l_id][0].setfoucsbyindex(this.gridrowindex, undefined, 'num');
				}
			}
			this.gridrowindex=rowindex;
			this.$emit('addedcallback', {
				gridrowindex:this.gridrowindex
			});
		},
		deleteRow(e, i, index) {
			//debugger
			i[i.colkey].splice(e.index, 1);
			if (i[i.colkey].length < 1&&this.isadd) {
				var newrow=JSON.parse(JSON.stringify(this.cargorow));
				newrow.rowid=this.$tool.createUniqueId();	
				i[i.colkey].push(newrow);
				this.gridrowindex=0;
			}
		},
		checkboxchange(e){
			var that=this;
			//debugger
			if(this.checkcountsum){
				var rows=[];
				if (!e.selectedall) 
					rows=e.rows;
				else
				{
					this.pageset[0].setlist.forEach(e=>{
						if(e.controltype=='table')
							rows=e[e.colkey];
					});
				}
				var amount=this.gridSumCol(undefined,rows);
				this.$emit('gridcallback', {
					event:'getsum',
					amount:amount,
					rows:rows
				});
			}
			this.checkedrows=[];
			if (!e.selectedall)
				this.checkedrows=e.rows;
			else
			{
				this.pageset[0].setlist.forEach(e=>{
					if(e.controltype=='table')
						this.checkedrows=e[e.colkey];
				});
			}
			if(this.ischecksingle){
				if(this.checkedrows.length>0){
					if(this.checkedrows.length>1){
						this.$refs['gridedit_'+this.l_id][0].$children[0].clearSelection();
						this.$refs['gridedit_'+this.l_id][0].$children[0].toggleRowSelection([{row:e.row, selected:true}]);
						this.$emit('gridcallback', {
							row:e.row,
							rowindex:e.row.index
						});
					}
					else
						this.$emit('gridcallback', {
							row:this.checkedrows[0],
							rowindex:this.checkedrows[0].index
						});
				}else{
					this.$emit('gridcallback', {
						rowindex:-1
					});
				}
			}
		},
		gridchange(e){
			//debugger
			var that=this;
			if(this.gridsum){
				this.gridSumCol(e);
			}
			//
			if(e.colindex!=undefined){
				if(this.columns[e.colindex].event=='setpackagenum'){
					this.setpackagenum(e.row);
				}
			}
		},
		gridSumCol(e,checkedrows){
			var that=this;
			var iscount=false;
			
			if(this.sumarycol.triggercols!=undefined&&e!=undefined){
				var list=this.sumarycol.triggercols.filter(function(b){
					return b.toString()==that.columns[e.colindex].field;
				});
				if(list.length>0)
					iscount=true;
			}else
				iscount=true;
				
			if(!iscount)
				return false;
			var tablegrid=[];
			if(checkedrows==undefined){
				this.pageset[0].setlist.forEach(e=>{
					if(e.controltype=='table')
						tablegrid=e[e.colkey];
				});
			}
			else
				tablegrid=checkedrows;
				
			if(tablegrid.length>0){
				var sumlist=[];
				var value=0;
				for(var i=0;i<tablegrid.length;i++){
					if(this.sumarycol.cols.length>1)
					{
						var e=tablegrid[i];
						var isgo=true;
						var value2='';
						this.sumarycol.cols.forEach(b=>{
							if(e[b]==''||isNaN(Number(e[b]))){
								isgo=false;
								return false;
							}else{
								if(value2=='')
									value2=Number(e[b]);
								else{
									if(this.sumarycol.counttype=='*')
										value2=value2*Number(e[b]);
									else if(this.sumarycol.counttype=='+')
										value2+=Number(e[b]);
								}
							}
						});
						if(isgo){
							value+=value2;
						}
					}
					else
						value+=Number(tablegrid[i][that.sumarycol.cols[0]]);
				}
				sumlist.push(
				{
					label:that.$lang.label.public.gridSumtitle,
					value:value
				});
				if(checkedrows==undefined){
					this.summarylist=sumlist;
					sumlist.forEach(b=>{
						that.amount=that.amount+Number(b.value);
					});
				}
				else
				{
					var amount=0;
					sumlist.forEach(b=>{
						amount=amount+Number(b.value);
					});
					return amount;
				}
			}
		},
		setrowclass({row, rowIndex}){
			//debugger
			row.index=rowIndex;
		},
		//弹窗里面点击确定时调用的事件
		dialogsrue(e){
			//debugger
			//读取商品
			if(e.l_id==571){
				if(this.gridrowindex==-1)
					this.gridrowindex=0;
				if(e.rows!=undefined)
				{
					this.addcargorow(e.rows,undefined,undefined,e.callbackparam);
					this.addnewrow(JSON.parse(JSON.stringify(this.cargorow)));
				}
			}
		},
		setpackagenum(e){
			//debugger
			if(e.num!=undefined&&e.num!=''&&e.unit!=''&&e.unit!=undefined){
				if(e.p_content!=''&&e.p_content!=undefined){
					var morespec=JSON.parse(e.p_content);
					morespec.forEach(b=>{
						if(b.unit==e.unit){
							e.packagenum=(Number(e.num)*Number(b.num)).toString();
							return false;
						}
					});
				}
			}
		},
		callbackFun(e){
			
		},
		getExpandsInfo(e){
			debugger
			var list=this.pageset[0].setlist[0][this.pageset[0].setlist[0].colkey];
			list[e.index].item={
				l_pagetype:'tablegridcontrol'
			}
			
			var orderinfo={};
			orderinfo[this.type+"_扩展"]=list[e.index].expandlist;
			list[e.index].urlparam={
				"id":e.index,
				'gridrowindex':e.index,
				"syscol":this.syscol,
				"type":this.type+"_扩展",
				"orderinfo":orderinfo
				};
			this.$refs['gridedit_'+this.l_id][0].SetExpandSonList(e.index);			
		}
	}
}
</script>

<style>
</style>